<template>
  <div class="Icy-road">
    <el-dialog title="道路结冰" :visible.sync="params.flag" v-dialogDrag :modal="false" :close-on-click-modal="false"
      :lock-scroll="false" :modal-append-to-body=false ref="cxtjRef"
      :before-close="() => params.flag && $parent.toggleProductView(params.productInfo.code)">
      <div slot="title" class="road-header">
        <span>道路结冰</span>
      </div>
       <div class="address">
        <img src="@/assets/images/地点.png" alt="">
        <span>{{ detail }}</span>
       </div>

      <div class="echart" ref="echartRef">

      </div>
    </el-dialog>
  </div>
</template>
<script>
import echarts from '@/config/echarts/index.js'
import { getIcyRoadOption } from '@/config/echarts/option/icy-rain'
import { apiData } from '@/api/index'
import { mapState } from 'vuex'
export default {
  props: ['params'],
  data () {
    return {
      detail: '',
      myEchart: null
    }
  },
  watch: {
    activeCountyId (id) {
      const index = this.objsList.findIndex(item => item.id === this.activeCountyId)
      index !== -1 && this.getGiftData(this.objsList[index].lat, this.objsList[index].lon)
    },
    'params.flag': {
      handler (flag) {
        flag && this.setZindex()
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('home', ['objsList', 'activeCountyId'])
  },
  mounted () {
    const index = this.objsList.findIndex(item => item.id === this.activeCountyId)
    index !== -1 && this.getGiftData(this.objsList[index].lat, this.objsList[index].lon)
  },
  methods: {

    async getGiftData (lat, lon) {
      lon = (Math.round(lon / 0.05) * 0.05).toFixed(2).replace(/\./g, '')
      lat = (Math.round(lat / 0.05) * 0.05).toFixed(2).replace(/\./g, '')
      const result = await apiData.giftData(lon, lat)
      console.log(result)
      const giftData = result

      const ptimestemp = result.ptimestemp
      const time = this.$moment(result.ptimestemp).format('HH')

      const timAarr = []
      const nowTime = new Date().getTime()
      let startTime = Date.now()
      let start = nowTime - time
      // const hourTime = 1000 * 60 * 60
      // if ((time === '08' && nowTime <= ptimestemp) || (time === '20' && nowTime <= ptimestemp)) {
      //   start = 0
      //   startTime = ptimestemp
      // } else if ((time === '08' || time === '20') && nowTime > ptimestemp) {
      //   const diff = Math.floor((nowTime - ptimestemp) / hourTime)
      //   start = diff
      //   startTime = ptimestemp + diff * 3600000
      // }
      start = 0
      startTime = ptimestemp + 3600000

      for (let i = 0; i < 72; i++) {
        const value = startTime + 3600000 * i
        // const time = this.$moment(value).format('DD日HH时')
        timAarr.push(value)
      }
      const temp = giftData.gift_t.slice(start, start + 72)
      const hourrf = giftData.gift_rain.slice(start, start + 72)
      const luTemps = []

      const objItem = this.objsList.find(item => item.id === this.activeCountyId)
      this.detail = objItem.name + this.$moment(timAarr[0]).format('MM月DD日HH时') + '-' + this.$moment(timAarr[timAarr.length - 1]).format('MM月DD日HH时')
      temp.forEach((item, index) => {
        let tempL = 0
        const h = Number(this.$moment(timAarr[index]).format('HH'))
        if (objItem.name.includes('分水坳大桥')) {
          if (h > 9 < 20) {
            tempL = 1.074690 * item + 0.452723
          } else {
            tempL = 1.0174 * item + 0.168866
          }
        } else if (objItem.name.includes('柯木湾二号桥')) {
          if (h > 9 < 20) {
            tempL = 1.127450 * item + 0.263125
          } else {
            tempL = 1.032304 * item + 0.061904
          }
        } else if (objItem.name.includes('云雾大桥')) {
          if (h > 9 < 20) {
            tempL = 1.060632 * item + 0.564431
          } else {
            tempL = 1.060632 * item + 0.564431
          }
        } else if (objItem.name.includes('九嶷山')) {
          if (h > 9 < 20) {
            tempL = 1.046756 * item + 0.396726
          } else {
            tempL = 1.046756 * item + 0.396726
          }
        }
        luTemps.push(Math.floor(tempL * 10) / 10)
      })
      const timeArr = timAarr.map(item => {
        item = this.$moment(item).format('DD日HH时')
        return item
      })
      const riskArr = []
      const splitArr = [[]]
      let index1 = 0
      luTemps.forEach((item, index) => {
        if (item < 2) {
          if (!splitArr[index1][0]) {
            splitArr[index1][0] = { xAxis: timeArr[index] }
          }
          if (splitArr[index1][0] && index === luTemps.length - 1) {
            splitArr[index1][1] = { xAxis: timeArr[index] }
          }
          riskArr.push(item)
        } else {
          if (splitArr[index1][0] && !splitArr[index1][1]) {
            splitArr[index1][1] = { xAxis: timeArr[index - 1] }
            index1++
            splitArr[index1] = []
          }
          riskArr.push('--')
        }
        if (index === luTemps.length - 1 && splitArr[index1].length === 0) {
          splitArr.splice(index1, 1)
        }
      })
      const option = getIcyRoadOption(timeArr, temp, luTemps, hourrf, riskArr, splitArr)
      this.$nextTick(() => {
        if (!this.myEchart) {
          this.myEchart = echarts.init(this.$refs.echartRef)
        }
        this.myEchart.setOption(option)
        this.myEchart.resize()
      })
    },

    // 设置弹出框的zIndex
    setZindex () {
      this.$nextTick(() => {
        const el = this.$refs.cxtjRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    }
  }
}
</script>
<style lang="less" scoped>
.Icy-road{
  display: flex;
  flex-direction: column;
  pointer-events: none;
  .road-header{
    font-size: 18px;
    font-weight: 600;
    color: #2D74F5;
  }
  .address{
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    img{
      width: 18px;
      margin-right: 12px;
    }
    span{
      font-size: 16px;
      color: #333333;
    }
  }
  .echart{
    flex: 1;
  }
}
  /deep/.el-dialog__wrapper {
    overflow: hidden;
    .el-dialog {
      width: 52vw;
      height: 26.67vw;
      background: #FFFFFF;
      box-shadow: 0vw 0vw 0.57vw 0vw rgba(139, 139, 139, 0.54);
      border-radius: 0.63vw;
      pointer-events: auto;
    }
  }
</style>
